<form #form="ngForm">
    <ng-container *ngIf="goal">
        <app-segment-header title="performance.goal-metrics.title"></app-segment-header>
        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'performance.goal-metrics.formFields.metricType.label' | translate
                }}</mat-label>
                <mat-select
                    placeholder="{{ 'performance.goal-metrics.formFields.metricType.placeholder' | translate }}"
                    name="metric_type"
                    required
                    #metric="ngModel"
                    [(ngModel)]="goal.metricType"
                    (ngModelChange)="metricTypeChange($event)"
                >
                    <mat-option value="dollar">
                        {{ 'performance.goal-metrics.formFields.metricType.options.dollar' | translate }}
                    </mat-option>
                    <mat-option value="percent">
                        {{ 'performance.goal-metrics.formFields.metricType.options.percent' | translate }}
                    </mat-option>
                    <mat-option value="number">
                        {{ 'performance.goal-metrics.formFields.metricType.options.number' | translate }}
                    </mat-option>
                    <mat-option value="binary">
                        {{ 'performance.goal-metrics.formFields.metricType.options.binary' | translate }}
                    </mat-option>
                    <mat-option value="milestones">
                        {{ 'performance.goal-metrics.formFields.metricType.options.milestones' | translate }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="metric.invalid">{{ metric.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field *ngIf="['dollar', 'number'].includes(goal.metricType)" class="columns-4 small-columns-12">
                <mat-label>{{ 'performance.goal-metrics.formFields.metricValue.label' | translate }}</mat-label>
                <input
                    matInput
                    type="number"
                    required
                    name="metric_value"
                    #metricValue="ngModel"
                    [(ngModel)]="goal.metricValue"
                />
                <mat-error *ngIf="metricValue.invalid">{{ metricValue.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <ng-container *ngIf="['milestones'].includes(goal.metricType)">
            <div class="app-grid" *ngFor="let milestone of goal.metricMilestones; let index = index">
                <div class="columns-8 small-columns-12 app-grid centered">
                    <mat-form-field class="columns-5">
                        <mat-label>{{
                            'performance.goal-metrics.formFields.metricMilestones.label' | translate
                        }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="title-{{ index }}"
                            required
                            #title="ngModel"
                            placeholder="{{
                                'performance.goal-metrics.formFields.metricMilestones.placeholder' | translate
                            }}"
                            [(ngModel)]="milestone.label"
                        />
                        <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="columns-5">
                        <mat-label>{{
                            'performance.goal-metrics.formFields.metricMilestonesDescription.label' | translate
                        }}</mat-label>
                        <input
                            matInput
                            type="text"
                            name="description-{{ index }}"
                            placeholder="{{
                                'performance.goal-metrics.formFields.metricMilestonesDescription.placeholder'
                                    | translate
                            }}"
                            [(ngModel)]="milestone.description"
                        />
                    </mat-form-field>

                    <div class="columns-2">
                        <mat-icon *ngIf="index !== 0" (click)="removeMilestone(index)" svgIcon="trash"></mat-icon>
                    </div>
                </div>
            </div>

            <ui-button
                type="link"
                (click)="$event.preventDefault(); $event.stopPropagation(); addMilestone()"
                class="align-left"
            >
                {{ 'performance.goal-metrics.formFields.metricMilestones.addMilestone' | translate }}
            </ui-button>
        </ng-container>
    </ng-container>
</form>
